import React, { useContext, useState, useEffect, useMemo, } from 'react'
import useHistoryCell from '../../tablecells/History'
import useOrderCell from '../../tablecells/Orders';
import useTransactionCell from '../../tablecells/Transaction';
import { ThemeContext } from '../../../context/ThemeContext'
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Menu, MenuItem, TextField, TableSortLabel, IconButton, Popover, MenuList, ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { ArrowRight } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check"
import '../../../App.scss'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SearchIcon from "@mui/icons-material/Search";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import CloseIcon from "@mui/icons-material/Close";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import HistoryFooter from '../../footer/HistoryFooter';
import { useDispatch, useSelector } from "react-redux";
import { setAccountHistoryData } from '../../../store/Slices/orderPositionSlice';
import { TableVirtuoso } from "react-virtuoso";
import { getAccountHistory } from '../../../api/request/dashboard/dashboard'
import { getCookies } from '../../../services/Cookies';


export default function History() {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { darkMode } = useContext(ThemeContext);
  const [contextMenu, setContextMenu] = useState(null);
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const [submenuType, setSubmenuType] = useState(null);
  const { accountId:accountID } = useSelector(state => state.accountSummary)
  const creation = localStorage.getItem('creation');
  const [filterPeriod, setFilterPeriod] = useState("Today");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [customDateRange, setCustomDateRange] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSymbol, setSelectedSymbol] = useState("");
  const [selectedType, setSelectedType] = useState("Trades");
  const [historyVisible, setHistoryVisible] = useState({});
  const [orderVisible, setOrderVisible] = useState({});
  const [transactionVisible, setTransactionVisible] = useState({});
  const orderCell = useOrderCell()
  const TransactionCell = useTransactionCell()
  const HistoryCell = useHistoryCell()
  const accountHistory = useSelector((state) => state.orderPosition.accountHistory);
  const [columnsToRender, setColumnsToRender] = useState(
    selectedType === "Trades" ? HistoryCell : selectedType === "Orders" ? orderCell : TransactionCell
  );
    const clientId = getCookies("clientId");
    const componentName = 'History'
    const storageKey = `hiddenColumns_${clientId}_${componentName}_${selectedType}`;

    const getInitialVisibleColumns = () => {
      const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
      const currentColumns = selectedType === "Trades" ? HistoryCell : selectedType === "Orders" ? orderCell : TransactionCell;
    
      if (storedHiddenColumns) {
        return currentColumns.reduce((acc, col) => ({
          ...acc,
          [col.title]: !storedHiddenColumns.includes(col.title),
        }), {});
      }
    
      return currentColumns.reduce((acc, col) => ({ ...acc, [col.title]: true }), {});
    };
    
  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);



  const getVisibleColumns = () => {
    switch (selectedType) {
      case "Trades":
        return historyVisible;
      case "Orders":
        return orderVisible;
      default:
        return transactionVisible;
    }
  };
  const setVisibleColumns_ = (newColumns) => {
    switch (selectedType) {
      case "Trades":
        setHistoryVisible(newColumns);
        break;
      case "Orders":
        setOrderVisible(newColumns);
        break;
      default:
        setTransactionVisible(newColumns);
    }
  };


  useEffect(() => {
    const newColumns = selectedType === "Trades" ? HistoryCell : selectedType === "Orders" ? orderCell : TransactionCell;
    setColumnsToRender(newColumns);

    const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
    if (storedHiddenColumns) {
      setVisibleColumns(
        newColumns.reduce((acc, col) => ({
          ...acc,
          [col.title]: !storedHiddenColumns.includes(col.title) 
        }), {})
      );
    } else {
      setVisibleColumns(
        newColumns.reduce((acc, col) => ({ ...acc, [col.title]: true }), {})
      );
    }
}, [selectedType]);




  const formatDateWithoutMilliseconds = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  const getStartOfDay = (date) => {
    return formatDateWithoutMilliseconds(new Date(date.setHours(0, 0, 0, 0)));
  };

  const getStartOfLastWeek = () => {
    let date = new Date();
    let day = date.getDay(); // Get current day (0 = Sunday, 1 = Monday, ..., 6 = Saturday)

    let diffToLastMonday = day === 0 ? -6 : 1 - day; // Adjust to the previous Monday
    date.setDate(date.getDate() + diffToLastMonday - 7); // Move to last week's Monday
    date.setHours(0, 0, 0, 0); // Start of the day

    return date;
  };

  const getEndOfLastWeek = () => {
    let startOfLastWeek = getStartOfLastWeek();
    let endOfLastWeek = new Date(startOfLastWeek);
    endOfLastWeek.setDate(endOfLastWeek.getDate() + 6); // Move to last week's Sunday
    endOfLastWeek.setHours(23, 59, 59, 999); // End of the day

    return endOfLastWeek;
  };

  const getStartOfLastMonth = () => {
    let date = new Date();
    date.setMonth(date.getMonth() - 1, 1); // Set to the 1st of the previous month
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const getEndOfLastMonth = () => {
    let date = new Date();
    date.setDate(1); // Move to the 1st of the current month
    date.setHours(0, 0, 0, 0);
    date.setMilliseconds(-1); // Set to the last moment of the previous month
    return date;
  };





  const getStartOfLast3Months = () => dayjs().subtract(3, "month").startOf("month").toISOString();
  const getStartOfLast6Months = () => dayjs().subtract(6, "month").startOf("month").toISOString();
  const getStartOfLastYear = () => dayjs().subtract(1, "year").startOf("month").toISOString();

  useEffect(() => {
    let fromDateTemp;
    let toDateTemp = formatDateWithoutMilliseconds(new Date().toISOString()); // Set to current date

    if (filterPeriod === "Today") {
      fromDateTemp = getStartOfDay(new Date());
    } else if (filterPeriod === "Last Week") {
      // fromDateTemp = getStartOfWeek();
      const lastWeekStart = getStartOfLastWeek(); // Get start of last week (Monday)
      const lastWeekEnd = getEndOfLastWeek(); // Get end of last week (Sunday)

      fromDateTemp = formatDateWithoutMilliseconds(lastWeekStart);
      toDateTemp = formatDateWithoutMilliseconds(lastWeekEnd);

    } else if (filterPeriod === "Last Month") {
      fromDateTemp = getStartOfLastMonth();
    } else if (filterPeriod === "Custom") {
      fromDateTemp = getStartOfDay(fromDate);
      toDateTemp = getStartOfDay(toDate);
    } else if (filterPeriod === 'Last 3 Months') {
      fromDateTemp = getStartOfLast3Months();
    } else if (filterPeriod === 'Last 6 Months') {
      fromDateTemp = getStartOfLast6Months();
    } else if (filterPeriod === 'Last Year') {
      fromDateTemp = getStartOfLastYear();
    }
    else {
      fromDateTemp = creation
        ? formatDateWithoutMilliseconds(new Date(creation).toISOString())
        : formatDateWithoutMilliseconds(new Date().toISOString());
    }

    setFromDate((prevFromDate) => (prevFromDate.toISOString() !== new Date(fromDateTemp).toISOString() ? new Date(fromDateTemp) : prevFromDate));
    setToDate((prevToDate) => (prevToDate.toISOString() !== new Date(toDateTemp).toISOString() ? new Date(toDateTemp) : prevToDate));
  }, [filterPeriod, creation]);

  useEffect(() => {
    if (!accountID) return;

    const requestData = {
      from: formatDateWithoutMilliseconds(fromDate),
      to: formatDateWithoutMilliseconds(toDate),
      id: Number(accountID),
    };
    // console.log(response);
    const fetchAccountHistory = async () => {
      try {
        const response = await getAccountHistory(requestData);
        const data = response.data;
        console.log(`data ${data}`);
        dispatch(setAccountHistoryData(data))
      }
      catch (error) {
        console.error("Error fetching account history:", error);
      }
    }
    fetchAccountHistory()
  }, [accountID, fromDate, toDate]);



  const handleContextMenu = (event, row) => {
    event.preventDefault();
    setContextMenu({ mouseX: event.clientX + 2, mouseY: event.clientY - 6, row });
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setSubmenuAnchor(null);
    setSubmenuType(null);
    setCustomDateRange(false)
  };

  const sortedHistory = accountHistory.length && [...accountHistory].sort((a, b) => {
    if (!sortConfig.key) return 0; // No sorting applied

    const valueA = a[sortConfig.key];
    const valueB = b[sortConfig.key];

    if (typeof valueA === 'number' && typeof valueB === 'number') {
      return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
    }
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }
    return 0;
  });
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const filteredHistory = sortedHistory.length && sortedHistory.filter(row =>
    (
      (selectedType === "Trades" && row.type === 10) ||
      (selectedType === "Orders" && row.type !== 10 && row.type !== 1 && row.type !== 0) ||
      (selectedType === "Transaction" && row.type === 1)
    ) &&
    (selectedSymbol ? (row.symbolData?.name || row.symbolName || "").trim().toLowerCase() === selectedSymbol.trim().toLowerCase() : true) &&
    // (selectedSymbol ? (row.symbolData?.name || "").trim().toLowerCase() === selectedSymbol.trim().toLowerCase() : true) &&
    (!searchQuery || Object.values(row).some(value => value?.toString().toLowerCase().includes(searchQuery.toLowerCase())))
  );

  const uniqueSymbols = [...new Set(filteredHistory.map(trade => trade.symbolName))].filter(Boolean);
  const totalProfitLoss = filteredHistory.reduce((total, row) => total + (row.profitLoss || 0), 0);

  const handleToggleSearchBar = () => {
    setShowSearchBar(prev => !prev);
    setSearchQuery('');
  };

  const handleOpenFilterMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseFilterMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectSymbol = (symbol) => {
    setSelectedSymbol(symbol === "All" ? "" : symbol); // Empty string means all symbols
    setAnchorEl(null);
  };

  const actions = [
    { icon: <SearchIcon />, name: "Search", onClick: handleToggleSearchBar },
    { icon: <CurrencyExchangeIcon />, name: "Filter by Symbol", onClick: handleOpenFilterMenu }
  ];

  const handleMenuItemClick = (type) => {
    setSelectedType(type);
    handleCloseContextMenu();
  };

  const toggleColumnVisibility = (title) => {
    setVisibleColumns((prev) => {
      const updatedColumns = { ...prev, [title]: !prev[title] };
  
      setTimeout(() => {
        localStorage.setItem(storageKey, JSON.stringify(
          Object.keys(updatedColumns).filter(col => !updatedColumns[col])
        ));
      }, 100);
  
      return updatedColumns;
    });
  };
  


  const resetAllColumns = () => {
    setVisibleColumns((prev) => {
      const resetColumns = columnsToRender.reduce(
        (acc, col) => ({ ...acc, [col.title]: true }),
        {}
      );
  
      setTimeout(() => {
        localStorage.removeItem(storageKey);
      }, 100);
  
      return resetColumns;
    });
  };
  


  const deposit =
    selectedType === "Transaction"
      ? sortedHistory
        .filter(row => row.type === 1)
        .reduce((total, row) => total + (row.amount || 0), 0)
      : 0;

  const Row = useMemo(() => (index, row) => {
    return <>
      {columnsToRender
        .filter(col => visibleColumns[col.title])
        .map((col, colIndex) => {
          return (
            <>
              {visibleColumns[col.title] ? (
                <TableCell onContextMenu={(event) => handleContextMenu(event, row)} key={colIndex} sx={{
                  fontSize: "0.8rem", border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: "hidden",
                  color: col.dataIndex === "type" ? row.type === 1 ? "primary.main" : "secondary.main"
                    : col.dataIndex === "profitLoss" ? row.profitLoss < 0 ? "#da5244" : row.profitLoss > 0 ? "#3687ed" : "inherit"
                      : col.dataIndex === "openTicket" ? row.status === "DONE" ? "green" : row.status === "CANCEL" ? "red" : "inherit"
                        : "inherit",
                }}
                >
                  {
                    col.dataIndex === "side"
                      ? row.side === 1
                        ? "Buy"
                        : "Sell"
                      : col.dataIndex === "comment"
                        ? row.comment || ""
                        : col.dataIndex === "openTicket"
                          ? row.status === "DONE"
                            ? `${row.status} - ${row.closeTicket ?? row.openTicket}`
                            : row.closeTicket == null
                              ? row.openTicket
                              : row.closeTicket
                          // : row.status === "CANCEL"
                          // ? row.status
                          : col.render(row[col.dataIndex])
                  }
                </TableCell>
              ) : null}
            </>
          );
        })}
    </>
  }, [columnsToRender,visibleColumns,darkMode,selectedType])

  const fixedHeaderContent = () => {
    return <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}>
      {columnsToRender.map(
        (col, index) => visibleColumns[col.title] && (
          <TableCell onContextMenu={(event) => handleContextMenu(event, col)} key={index} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", cursor: "pointer", border: "none", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, position: 'sticky', top: 0, zIndex: 2 }} onClick={() => handleSort(col.dataIndex)}>
            {col.title === `${t('time')}` ? (
              <>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                  <span>{col.title}</span>
                  {selectedType !== `${t('transaction')}` && (
                    <ToggleButtonGroup value={selectedType} exclusive onChange={(event, newValue) => newValue && setSelectedType(newValue)} sx={{ display: "flex", gap: "4px" }}>
                      <ToggleButton value={t('trades')} sx={{ backgroundColor: selectedType === `${t('trades')}` ? "primary.main" : "transparent", color: selectedType === `${t('trades')}` ? "white" : "black", fontSize: "0.7rem", padding: "1px 6px", borderRadius: "5px", "&.Mui-selected": { backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } } }}>T</ToggleButton>
                      <ToggleButton value={t('orders')} sx={{ backgroundColor: selectedType === `${t('orders')}` ? "primary.main" : "transparent", color: selectedType === `${t('orders')}` ? "white" : "black", fontSize: "0.7rem", padding: "1px 6px", borderRadius: "5px", "&.Mui-selected": { backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } } }}>O</ToggleButton>
                    </ToggleButtonGroup>
                  )}

                </Box>
              </>
            ) : (
              <TableSortLabel active={sortConfig.key === col.dataIndex} direction={sortConfig.direction}>{col.title}</TableSortLabel>
            )}
          </TableCell>
        )
      )}
    </TableRow>
  }
  const VirtuosoTableComponents = {
    Table: (props) => (
      <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };

  return (
    <>
      <Paper style={{ width: "100%", height: "100%", position: 'relative' }}>
        {showSearchBar && (
          <Paper sx={{ position: "absolute", top: 10, right: 10, padding: "1px", zIndex: 10, display: "flex", alignItems: "center", borderRadius: 50, width: '25%', boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", backgroundColor: darkMode ? "#202933" : "#d5d5d5" }}>
            <TextField size="small" variant="outlined" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1, }} />
            <IconButton onClick={handleToggleSearchBar}><CloseIcon sx={{ fontSize: 15 }} /></IconButton>
          </Paper>
        )}
        <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleCloseFilterMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
          <MenuList sx={{ backgroundColor: darkMode ? "#202933" : "#fff", }}>
            {uniqueSymbols.length > 0 && (
              <MenuItem onClick={() => handleSelectSymbol("All")} sx={{ fontSize: 13.5, }}>All Symbols</MenuItem>
            )}
            {uniqueSymbols.length > 0 ? uniqueSymbols.map((symbol, index) => (
              <MenuItem key={index} onClick={() => handleSelectSymbol(symbol)} sx={{ fontSize: 13.5, }}>{symbol}</MenuItem>
            )) : <MenuItem disabled sx={{ fontSize: 13.5, }}>No Symbols Available</MenuItem>}
          </MenuList>
        </Popover>

        <SpeedDial ariaLabel="SpeedDial search filter" sx={{ position: "fixed", bottom: 0, right: 10, transform: "scale(0.7)" }} icon={<SpeedDialIcon />}>
          {actions.map((action) => (
            <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
          ))}
        </SpeedDial>
        <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
          <TableVirtuoso data={filteredHistory} itemContent={Row} fixedHeaderContent={fixedHeaderContent} components={VirtuosoTableComponents}> </TableVirtuoso>
        </Box>
        <Box sx={{ border: "none", p: 1, backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }}>

          <HistoryFooter totalProfitLoss={totalProfitLoss} deposit={selectedType === "Transaction" ? deposit : 0} />
        </Box>
      </Paper>

      <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "var(--white)", color: darkMode ? "var(--lightText)" : '#var(--darkText)' }}>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={() => handleMenuItemClick("Trades")}>{t('trades')}</MenuItem>
          <MenuItem sx={{ fontSize: 13.5 }} onClick={() => handleMenuItemClick("Orders")}>{t('orders')}</MenuItem>
          <MenuItem sx={{ borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, fontSize: 13.5 }} onClick={() => handleMenuItemClick("Transaction")}>{t('transaction')}</MenuItem>

          <MenuItem onClick={(e) => { setSubmenuAnchor(e.currentTarget); setSubmenuType("Period"); }} sx={{ fontSize: 13.5 }}>{t('period')} <ArrowRight /></MenuItem>
          <MenuItem onClick={(e) => { setSubmenuAnchor(e.currentTarget); setSubmenuType("Columns"); }} sx={{ fontSize: 13.5 }}>{t('columns')} <ArrowRight /></MenuItem>
        </div>
      </Menu>

      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={Boolean(submenuAnchor)} anchorEl={submenuAnchor} onClose={handleCloseContextMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "", color: darkMode ? "var(--lightText)" : '#var(--darkText)' }}>
          {submenuType === "Period" ? (
            <>
              {["Today", "Last Week", "Last Month", "Last 3 Month", 'Last 6 Month', 'All History'].map((period) => (
                <MenuItem key={period} onClick={() => { setFilterPeriod(period); setSubmenuAnchor(null); }} sx={{ fontSize: 13.5 }}>{period}</MenuItem>
              ))}
              <MenuItem key="Custom Range" onClick={() => { setFilterPeriod("Custom"); setCustomDateRange(prev => !prev); }} sx={{ fontSize: 13.5 }}>{t('customRange')}</MenuItem>

              {customDateRange && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div style={{ display: 'flex', padding: '8px', color: darkMode ? "var(--lightText)" : '#var(--darkText)' }}>
                    <DatePicker sx={{ padding: 0, }} label={t('fromDate')} value={dayjs(fromDate)} onChange={(newValue) => setFromDate(newValue)} renderInput={(params) => <TextField sx={{ padding: 0 }} {...params} />} />
                    <DatePicker sx={{ padding: 0 }} label={t('toDate')} value={dayjs(toDate)} onChange={(newValue) => setToDate(newValue)} renderInput={(params) => <TextField sx={{ padding: 0 }} {...params} />} />
                  </div>
                </LocalizationProvider>
              )}
            </>
          ) : (
            <>
              {columnsToRender.filter(col => col.title !== `${t('symbol')}` && col.title !== `${t('profit')}`).map((col, index) => (
                <MenuItem key={index} onClick={() => toggleColumnVisibility(col.title)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {col.title} {visibleColumns[col.title] && <CheckIcon sx={{ fontSize: 18, color: "#4597ff" }} />}
                </MenuItem>
              ))}
              <MenuItem onClick={resetAllColumns} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }}>{t("resetAll")}</MenuItem>
            </>
          )}
        </div>
      </Menu>
    </>)
}
